export const FreeList = [
  'Unlimited team members & projects',
  'Track time on projects & tasks',
  'Set billable rates',
  'Generate detailed reports',
];
export const ProList = [
  'Everything in free PLUS',
  'Priority support',
  'Generate client invoices',
  'Add & edit logs on behalf of your team',
  'Approval workflow with Audit log',
  'Extra features…',
];

export const Track = [
  { title: 'Timer or add manually', free: true, pro: true },
  { title: 'Timesheet - weekly tracking', free: true, pro: true },
  { title: 'Timer - daily tracking', free: true, pro: true },
  { title: 'Timeline view', free: true, pro: true },
  { title: 'Favourites', free: true, pro: true },
  { title: 'Expenses', free: true, pro: true },
  { title: 'Detailed description and attachments', free: true, pro: true },
  { title: 'Daily tracking reminder (mobile app)', free: true, pro: true },
  { title: 'Bulk edit or delete logs', free: false, pro: true },
  { title: 'Track custom fields (numeric)', free: false, pro: true },
];
export const Organize = [
  { title: 'Unlimited projects, task and clients', free: true, pro: true },
  { title: 'Task and project templates', free: true, pro: true },
  { title: 'Task and project description', free: true, pro: true },
  { title: 'Group task and mark as done', free: true, pro: true },
  { title: 'Budget hours, billable or cost amounts', free: false, pro: true },
  { title: 'Budget alerts to email', free: false, pro: true },
  { title: 'Monthly budget', free: false, pro: true },
  { title: 'Task budget or estimates', free: false, pro: true },
  { title: 'Assign task to team members', free: false, pro: true },
];
export const Biling = [
  { title: 'Billable rate per project', free: true, pro: true },
  { title: 'Billable rate per tasks or team member', free: false, pro: true },
  { title: 'Labor costs (Team costs', free: false, pro: true },
  { title: 'Calculate profit & loss', free: false, pro: true },
  { title: 'Auto-roound billable time', free: false, pro: true },
  { title: 'Invoicing', free: false, pro: true },
];
export const Report = [
  { title: 'Dashboard', free: true, pro: true },
  { title: 'Customize a detailed report (Activity)', free: true, pro: true },
  { title: 'Download to PDF, export to XLS', free: true, pro: true },
  { title: 'Send reports to Email', free: true, pro: true },
  { title: 'Timesheets report', free: true, pro: true },
  { title: 'Schedule detailed reports to email', free: false, pro: true },
  { title: 'Team pivot report', free: false, pro: true },
  { title: 'Economy report', free: false, pro: true },
  { title: 'Download & customize reorts in Excel', free: false, pro: true },
  { title: 'Own logo on PDF reports', free: false, pro: true },
];
export const Team = [
  { title: 'Unlimited team members', free: true, pro: true },
  { title: 'Role: Administrator', free: true, pro: true },
  { title: 'Role: Normal member', free: true, pro: true },
  { title: 'Role: Project manager', free: false, pro: true },
  { title: 'Group members into Teams', free: false, pro: true },
  { title: 'Hide billing and cost details', free: false, pro: true },
  { title: 'Require project and task input', free: false, pro: true },
  { title: 'Approval workflow', free: false, pro: true },
  { title: "Add, edits and team's log", free: false, pro: true },
  { title: 'Auto-lock time logs', free: false, pro: true },
  { title: 'Tracking reminder', free: false, pro: true },
  { title: 'Audit log report', free: false, pro: true },
  { title: "Track team's capacity", free: false, pro: true },
];
export const Integration_and_Apps = [
  { title: 'Import timesheets, projects and clients', free: true, pro: true },
  { title: 'Mobile apps', free: true, pro: true },
  { title: 'Api access', free: true, pro: true },
  { title: 'Zapier integration', free: true, pro: true },
  { title: 'Quickbooks native integration', free: false, pro: true },
];
export const Frequently_asked_questions = [
  {
    question: 'Will I be charged after the 14 day trial?',
    answer:
      "No, you don't have to enter your credit card details to start your Free trial. When you decide to continue using My Hours, enter your payment details and you'll be automatically charged each period (monthly or annually).",
  },
  {
    question: 'Can I switch to free account after the Pro trial ends?',
    answer:
      "Sure! You'll always have a choice between staying on the Pro version that comes with a subscription or downgrading to a Free account. Just keep in mind that you will lose access to Pro features.",
  },
  {
    question: 'What if we need more than 14 days to test the Pro edition?',
    answer:
      "Just send us an email to support@myhours.com and we'll provide you with an extension.",
  },
  {
    question: "What's included in the Pro Trial?",
    answer:
      'Pro Trial comes with every feature that My Hours offers. If you have trouble finding a functionality you need, send us an email.',
  },
  {
    question: 'What kind of payment di you accept?',
    answer:
      'We accept Visa, MasterCard, American Express, Discover, and PayPal. Additional payment options, including wire transfer, are available for larger teams with 10+ members and an annual payment.',
  },
  {
    question: 'Do you offer discounts?',
    answer: 'We offer discounts to non-profit companies and larger teams.',
  },
  {
    question: 'What type of support is included?',
    answer:
      'All My Hours users receive email support, while Pro customers can also engage via live chat. Our typical response time is less than 24 hours. Teams with 3+ members can sign up for a free training here.',
  },
  {
    question: 'Can I get a refund?',
    answer:
      'We issue a refund when My Hours account with active subscription was not being used for a few months.',
  },
  {
    question: 'Can I deactivate inactive team members?',
    answer:
      'You can archive inactive team members while keeping their data for reporting. We do not charge for archived team members.',
  },
];
export const Feature = {
  Track,
  Organize,
  Biling,
  Report,
  Team,
  Integration_and_Apps,
};
